import { defineComponent, openBlock, createElementBlock, createStaticVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "CircleClose"
});
const _hoisted_1 = {
  width: "16px",
  height: "16px",
  viewBox: "0 0 16 16",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-792.000000, -2336.000000)" fill="currentColor"><g transform="translate(580.000000, 2324.000000)"><g transform="translate(212.000000, 12.000000)"><path d="M7.99998531,1.5 C11.5898551,1.5 14.5,4.4101592 14.5,8 C14.5,11.5898551 11.5898707,14.5 7.99998531,14.5 C4.41014451,14.5 1.5,11.5898551 1.5,8 C1.5,4.4101592 4.4101592,1.5 7.99998531,1.5 Z M10.2521776,5.03515625 L8.118,7.17 L5.98386502,5.03515625 L5.0372925,5.98172877 L7.172,8.116 L5.0372925,10.2500414 L5.98386502,11.1966138 L8.118,9.062 L10.2521776,11.1966138 L11.19875,10.2500414 L9.064,8.116 L11.19875,5.98172877 L10.2521776,5.03515625 Z"></path></g></g></g></g>', 1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var circleClose = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { circleClose as default };
